import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Grid } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { FieldArrayWithId, useFieldArray, UseFieldArrayReturn, } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CBConsentCompanyCode, CBCreationOfProps, IFormValues } from "../../types";
import { getCountryByCode } from "../../utils";
import CBConsentsAccordion from "./CBConsentsAccordion";
import CBConsentTab from "./CBConsentTab";

const CustomerBaseConsentDetails = ({ creationOf }: CBCreationOfProps) => {

    const { t } = useTranslation('customerbase');
    const isCreationMode = !!creationOf;
    const [isExpanded, setIsExpanded] = useState(false);
    const consentsFieldArray = useFieldArray<IFormValues, 'cbConsents'>({
        name: "cbConsents"
    });

    const [filteredCompanyCode, setFilteredCompanyCode] = useState<string[]>([]);
    const [filteredConsentArray, setFilteredConsentArray] = useState<any>();

    useEffect(() => {

        if (isCreationMode) return;

        let cc: string[] = []

        consentsFieldArray.fields.forEach((consent) => {
            if (!!consent.companyCode && !cc.includes(consent.companyCode)) {
                cc.push(consent.companyCode);
            }
        });
        setFilteredCompanyCode(cc);

        const groupedConsents = cc
            .filter(companyCode => companyCode === CBConsentCompanyCode.DRIVALIA_FRANCE)
            .map(companyCode => {
                const consentsForCompany = consentsFieldArray.fields.filter(c => c.companyCode === companyCode);
                return {
                    companyCode,
                    consent: consentsForCompany
                };
            });

        setFilteredConsentArray(groupedConsents);

    }, [consentsFieldArray.fields, isCreationMode]);

    return (
        <Accordion expanded={Boolean(isExpanded)} onChange={(_e, expanded) => {
            setIsExpanded(expanded);

        }}>
            <AccordionSummary expandIcon={<ExpandMore />}>
                {t("tabs.accordionsLabels.cbConsentDetails")
                /*isCreationMode ? 
                    t("tabs.accordionsLabels.cbConsentDetails") 
                    :
                 <UpdateBtnsAccordion
                    label={t("tabs.accordionsLabels.cbConsentDetails")}
                    editing={editing}
                    isExpanded={isExpanded}
                    disabledSave={formState.dirtyFields.cbConsents ? false : true}
                    onSetEditing={onSetEditing}
                    onResetForm={onResetForm}
                    onSave={onSave}
                    //showAdd={(consentsFieldArray.fields.length >= 0 && consentsFieldArray.fields.length <3)}
                    //onAdd={onAdd}
                />*/}
            </AccordionSummary>
            <AccordionDetails>
                <Grid container rowSpacing={1}>
                    {
                        filteredCompanyCode.map((cc) => (
                            <Fragment key={`fragment-consent-country-${cc}`}>
                                <Grid item xs={12} key={`consent-country-${cc}`}>
                                    <Accordion>
                                        <AccordionSummary expandIcon={<ExpandMore />}>
                                            {t(`labels.country.${getCountryByCode(cc)}`, { defaultValue: cc })}
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Grid container rowSpacing={1}>
                                                {
                                                    // Vista multi-channel SOLO per Francia
                                                    cc === CBConsentCompanyCode.DRIVALIA_FRANCE ? (
                                                        filteredConsentArray.map((consents: any, index: number) => (
                                                            (consents.companyCode === cc) &&
                                                            <Grid item md={12} xs={12} key={`consent-${consents.companyCode}-${index}`}>
                                                                <CBConsentTab
                                                                    consent={consents}
                                                                    creationOf={creationOf}
                                                                    index={index}
                                                                    fullConsentList={consentsFieldArray.fields}
                                                                />
                                                            </Grid>
                                                        ))
                                                    ) : (
                                                        (() => {
                                                            const consentsForCompany = consentsFieldArray.fields.filter((c) => c.companyCode === cc);
                                                            const termCondTypeMap = new Map<string, typeof consentsForCompany[0]>();
                                                            consentsForCompany.forEach((consent) => {
                                                                const key = consent.termCondType ?? '';
                                                                const existing = termCondTypeMap.get(key);
                                                                if (!existing) {
                                                                    termCondTypeMap.set(key, { ...consent });
                                                                } else if (consent.result === true && existing.result !== true) {
                                                                    termCondTypeMap.set(key, { ...consent });
                                                                }
                                                            });
                                                            return Array.from(termCondTypeMap.values())
                                                                .map((consent) => {
                                                                    const originalIndex = consentsFieldArray.fields.findIndex((c: any) => c.id === consent.id);
                                                                    return (
                                                                        <Grid item md={12} xs={12} key={`consent-${consent.id}`}>
                                                                            <CBConsentsAccordion
                                                                                creationOf={creationOf}
                                                                                index={originalIndex}
                                                                                consent={consent}
                                                                            />
                                                                        </Grid>
                                                                    );
                                                                });
                                                        })()
                                                    )
                                                }
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                            </Fragment>

                        ))
                    }
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default CustomerBaseConsentDetails;